import {
  FaUserCheck,
  FaSyncAlt,
  FaTimesCircle,
} from "react-icons/fa";
import { MdCalendarToday } from "react-icons/md";

export const FLIGHT_CHART_COLORS = [
  "#1E61DC",
  "#60A5FA",
  "#93C5FD",
  "#BFDBFE",
];

export const getFlightRevenueByClassChartData = (revenueByClassData) =>
  revenueByClassData?.data?.map((item) => ({
    name: item.cabinClass,
    value: item.revenue,
    percentage: item.percentage,
    bookings: item.bookings,
  })) || [];

export const getFlightPostTicketingIconMap = () => ({
  dateChange: {
    icon: <MdCalendarToday className="w-6 h-6 text-white" />,
    gradient: "from-blue-500 to-blue-600",
    shadow: "shadow-blue-500/30",
  },
  nameCorrection: {
    icon: <FaUserCheck className="w-6 h-6 text-white" />,
    gradient: "from-emerald-500 to-emerald-600",
    shadow: "shadow-emerald-500/30",
  },
  refund: {
    icon: <FaSyncAlt className="w-6 h-6 text-white" />,
    gradient: "from-orange-500 to-orange-600",
    shadow: "shadow-orange-500/30",
  },
  void: {
    icon: <FaTimesCircle className="w-6 h-6 text-white" />,
    gradient: "from-red-500 to-red-600",
    shadow: "shadow-red-500/30",
  },
});
